import type { ChangeEvent } from 'react';
import { Campo, type PropsCampo } from './Campo';
import { mascararMoeda } from '../../servicos/formato';

/**
 * Campo de valor em reais — `R$` na frente, `0,00` sempre, milhar pontuado.
 *
 * Todo campo de dinheiro do sistema passa por aqui (decisão da operação:
 * "todos os campos de valores precisam da pontuação no formato BRL"). O
 * texto que sai é o mascarado (`1.000.000,00`); quem grava lê com
 * `lerValorDigitado`, que já entendia esse formato. Para carregar um número
 * gravado no campo, use `moedaParaCampo`.
 */
export function CampoDeMoeda(
  props: Omit<PropsCampo, 'value' | 'onChange' | 'numerico' | 'prefixo' | 'inputMode' | 'type'> & {
    readonly value: string;
    readonly onChange: (texto: string) => void;
  },
): JSX.Element {
  const { value, onChange, ...resto } = props;
  return (
    <Campo
      {...resto}
      numerico
      prefixo="R$"
      placeholder={props.placeholder ?? '0,00'}
      value={mascararMoeda(value)}
      onChange={(ev: ChangeEvent<HTMLInputElement>) => onChange(mascararMoeda(ev.target.value))}
    />
  );
}
